import { createSelector } from 'reselect';

const selectPlans = (state: any) => state.plans;


export const selectPlansCurrentItem = createSelector([selectPlans], (plans) => plans.current);

export const selectPlansListItems = createSelector([selectPlans], (plans) => plans.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectPlansListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectPlansQueryItems = createSelector([selectPlans], (plans) => plans.query);

export const selectPlansCreatedItem = createSelector([selectPlans], (plans) => plans.create);

export const selectPlansUpdatedItem = createSelector([selectPlans], (plans) => plans.update);

export const selectPlansReadItem = createSelector([selectPlans], (plans) => plans.read);

export const selectPlansDeletedItem = createSelector([selectPlans], (plans) => plans.delete);

export const selectPlansSearchedItems = createSelector([selectPlans], (plans) => plans.search);

export const selectPlansItemsCount = createSelector([selectPlans], (plans) => plans.count);

export const selectPlansItemsFilter = createSelector([selectPlans], (plans) => plans.filter);